if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    static UNITS = [
      ['days', 86400],
      ['hours', 3600],
      ['minutes', 60],
      ['seconds', 1],
    ];

    constructor() {
      super();
      this.tick = this.tick.bind(this);
      this.intervalId = 0;
    }

    connectedCallback() {
      this.targetTime = Number(this.dataset.targetTimestamp) * 1000;
      this.unitElements = CountdownTimer.UNITS.map(([name]) =>
        this.querySelector(`[data-countdown-unit="${name}"]`)
      );

      this.tick();
      if (!this.hasEnded) this.intervalId = window.setInterval(this.tick, 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.intervalId);
    }

    tick() {
      let remaining = Math.floor((this.targetTime - Date.now()) / 1000);

      if (!this.targetTime || remaining <= 0) {
        this.end();
        return;
      }

      CountdownTimer.UNITS.forEach(([, unitSeconds], index) => {
        const value = Math.floor(remaining / unitSeconds);
        remaining -= value * unitSeconds;

        const element = this.unitElements[index];
        const text = String(value).padStart(2, '0');
        if (element && element.textContent !== text) element.textContent = text;
      });
    }

    end() {
      this.hasEnded = true;
      window.clearInterval(this.intervalId);
      (this.closest('.js-countdown-block') || this).hidden = true;
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
